import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightPointer = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 44,
	height: 127,
	viewBox: "0 0 44 127",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 119V8C0 3.58172 3.58172 0 8 0H15.389C18.7568 0 21.7639 2.10911 22.9108 5.27556L43.0132 60.7756C43.6508 62.5359 43.6508 64.4641 43.0132 66.2244L22.9108 121.724C21.7639 124.891 18.7568 127 15.389 127H8C3.58172 127 0 123.418 0 119Z",
		fill: "currentColor"
	})
});
export default SvgRightPointer;
